import Phaser from 'phaser';
import { SceneKeys } from './keys';
import { setRuntimeManifest, type RuntimeManifest } from '@/content/manifest';

/** Boot: fetch the generated asset manifest (optional, validated), then hand over to Preload. */
export class BootScene extends Phaser.Scene {
  constructor() { super(SceneKeys.BOOT); }
  create(): void {
    const url = `${import.meta.env.BASE_URL}assets/manifest.json`;
    fetch(url, { cache: 'no-cache' })
      .then(async (res) => {
        const type = res.headers.get('content-type') ?? '';
        if (!res.ok || !type.includes('json')) throw new Error(`manifest ${res.status} ${type}`);
        return (await res.json()) as RuntimeManifest;
      })
      .then((m) => { if (m && m.groups) setRuntimeManifest(m); else throw new Error('manifest has no groups'); })
      .catch((e: unknown) => console.warn('[load] no usable runtime manifest (public/assets/manifest.json); using static MANIFEST only', e))
      .finally(() => this.scene.start(SceneKeys.PRELOAD));
  }
}
